import { render, staticRenderFns } from "./DadosSegmentacao.vue?vue&type=template&id=659f645a&"
import script from "./DadosSegmentacao.vue?vue&type=script&lang=js&"
export * from "./DadosSegmentacao.vue?vue&type=script&lang=js&"
import style0 from "./DadosSegmentacao.vue?vue&type=style&index=0&id=659f645a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports